import { Card, CardActionArea, CardContent, Grid, TextField, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React from 'react'
import { useState } from 'react';
import { Pie } from 'react-chartjs-2';

const BdaSemDashboard = () => {
    const [rows, setRows] = useState('');

    const columns = [
        {   field: 'studentId', headerName: 'Student Id',
            minWidth: 100, flex: 1, align: 'left', headerAlign: 'center' },
        {   field: 'studentName', headerName: 'Student Name',
            minWidth: 100, flex: 1, align: 'left', headerAlign: 'center' },
        {   field: 'noOfClass', headerName: 'No Of Class',
            minWidth: 100, flex: 1, align: 'left', headerAlign: 'center' },
        {   field: 'subject', headerName: 'Subject',
            minWidth: 100, flex: 1, align: 'left', headerAlign: 'center' },
        {   field: 'percentage', headerName: 'Percentage',
            minWidth: 100, flex: 1, align: 'center', headerAlign: 'center' },
        // {   field: 'action', headerName: 'Action',
        //     minWidth: 100, flex: 1, align: 'center', headerAlign: 'center', sortable: false,
        //     cellClassname: 'actions',
        //     type: 'actions',
        //     getActions: (params) => [
        //         // <EditData selectedRow={params.row} />,
        //         <DeleteData selectedRow={params.row} />,
        //     ],
        // }
    ];
    return (
        <div>
            <Grid container spacing={2} 
            style={{
            display: 'flex',
            margin: '10px',
            width: 'inherit',
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            flexFlow: 'row wrap',
            alignContent: 'center',
            justifyContent: 'space-between'}}>
                <Grid item xs={12} sm={4} md={2} lg={2} xl={2}>
                    <Card style={{background:'#f7f7f7',height:'110px',width: '210'}}>
                        <CardActionArea>
                            <CardContent>
                                <Typography sx={{ fontSize: 20 }} color="text.secondary" gutterBottom>
                                Sem 1
                                </Typography>
                                <Typography sx={{ fontSize: 35 }} color="text.secondary">
                
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={4} md={2} lg={2} xl={2}>
                    <Card style={{background:'#f7f7f7',height:'110px',width: '210'}}>
                        <CardActionArea>
                            <CardContent>
                                <Typography sx={{ fontSize: 16 }} color="text.secondary" gutterBottom>
                                    No of Class
                                </Typography>
                                <Typography sx={{ fontSize: 30 }} color="text.secondary">
                                    20
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={4} md={2} lg={2} xl={2}>
                    <Card style={{background:'#f7f7f7',height:'110px',width: '210'}}>
                        <CardActionArea>
                            <CardContent>
                                <Typography sx={{ fontSize: 16 }} color="text.secondary" gutterBottom>
                                Canceled Class
                                </Typography>
                                <Typography sx={{ fontSize: 30 }} color="text.secondary">
                                3
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={4} md={2} lg={2} xl={2}>
                    <Card style={{background:'#f7f7f7',height:'110px',width: '210'}}>
                        <CardActionArea>
                            <CardContent>
                                <Typography sx={{ fontSize: 16 }} color="text.secondary" gutterBottom>
                                No of Absent
                                </Typography>
                                <Typography sx={{ fontSize: 30 }} color="text.secondary">
                                20
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={4} md={2} lg={2} xl={2}>
                    <Card style={{background:'#f7f7f7',height:'110px',width: '210'}}>
                        <CardActionArea>
                            <CardContent>
                                <Typography sx={{ fontSize: 16 }} color="text.secondary" gutterBottom>
                                Attendence shortage
                                </Typography>
                                <Typography sx={{ fontSize: 35 }} color="text.secondary">
                                5
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
            <Grid container spacing={1} style={{ marginTop: '20px'}}>
                <Grid item xs={12} sm={5} md={5} lg={5} lx={5}>
                    {/* <Pie
                        // onClick={onClipie} 
                        height='inherit'
                        width='inherit'
                    /> */}
                </Grid>
            </Grid>
            <Grid container spacing={2} style={{ marginTop: '20px'}}>
                <Grid item xs={12} sm={5} md={5} lg={5} lx={5}>
                    <DataGrid
                        style={{ height: 350,width:'100%' }}
                        // loading={loading}
                        rows={rows}
                        columns={columns}
                    />
                </Grid>
            </Grid>
        </div>
    )
}

export default BdaSemDashboard
